import React, {
    useEffect,
    createContext,
    useState,
    PropsWithChildren,
    useRef,
} from 'react';
import { useLocation } from 'react-router-dom';

// redux
import { IAppContextProps, IAppProps } from '../common/model/AppModels';
import { useDispatch, useSelector } from 'react-redux';
import { workspaceActions } from '../components/Workspace/WorkspaceActions';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AppContext = createContext<IAppContextProps>(undefined!);
const AppProviderWrapper: React.FC<PropsWithChildren<IAppProps>> = ({
    children,
}) => {
    const [currentPath, setCurrentPath] = useState<string>('');
    const [contactAnchorEl, setContactAnchorEl] =
        useState<HTMLButtonElement | null>(null);
    const location = useLocation();
    const dispatch = useDispatch();
    const currentUser = useSelector((state: any) => state.user.currentUser);
    const currentUserLoading = useSelector(
        (state: any) => state.user.currentUserLoading
    );
    const contactRef = useRef();
    const workspaceList = useSelector(
        (state: any) => state.workspace.workspaceList
    );
    const workspaceListLoading = useSelector(
        (state: any) => state.workspace.workspaceListLoading
    );

    useEffect(() => {
        dispatch(
            workspaceActions?.getWorkspaceList(1000, 0, 'createdAt', 'DESC')
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (currentPath !== location) {
            setCurrentPath(location.pathname);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    const handleClickOpenContact = () => {
        setContactAnchorEl(contactRef.current);
    };

    const handleCloseContact = () => {
        setContactAnchorEl(null);
    };

    return (
        <AppContext.Provider
            value={{
                currentPath,
                currentUser,
                currentUserLoading,
                handleClickOpenContact,
                handleCloseContact,
                contactAnchorEl,
                setContactAnchorEl,
                contactRef,
                workspaceList,
                workspaceListLoading,
            }}
        >
            {children}
        </AppContext.Provider>
    );
};

export default AppProviderWrapper;
